import { render } from "./package-total-info.vue?vue&type=template&id=6113db3e"
import script from "./package-total-info.vue?vue&type=script&lang=js"
export * from "./package-total-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__